import { render, staticRenderFns } from "./ChooseWasteOrServiceModal.vue?vue&type=template&id=f095e4d4&scoped=true&"
import script from "./ChooseWasteOrServiceModal.vue?vue&type=script&lang=js&"
export * from "./ChooseWasteOrServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./ChooseWasteOrServiceModal.vue?vue&type=style&index=0&id=f095e4d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f095e4d4",
  null
  
)

export default component.exports